import React, { useState } from 'react'
import FormControl from "@mui/material/FormControl";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import SearchIcon from '@mui/icons-material/Search';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { IconButton, MenuItem, Select } from '@mui/material';
import '../../css/searchBar.css';

export default function SearchBar({options, getData, calendar}) {
	const [selectItem, setSelectItem] = useState("none");
	const [inputValue, setInputValue] = useState("");
  	const [startDate, setStartDate] = useState(null);
	const [endDate, setEndDate] = useState(null);	

	const handleChange = (e) => {
		setSelectItem(e.target.value);
	}

	const handleInput = (e) => {
		setInputValue(e.target.value);
	}

	const searchHandle = (selectItem, inputValue, startDate, endDate) => {
		getData(selectItem, inputValue, startDate, endDate);
	}

	return (
		<Box
			component="form"
			// sx={{
			// 	'& .MuiTextField-root': { m: 1, width: '30ch' },
			// }}
			noValidate
			autoComplete="off"
		>
			{
				calendar ? (
					<>
						<LocalizationProvider dateAdapter={AdapterDayjs}>
							<span>작업일자 : </span>
							<DesktopDatePicker
								inputFormat={"YYYY-MM-DD"}
								mask={"____-__-__"}
								value={startDate}
								onChange={(newValue) => {
									if(newValue === null) {
										setStartDate(null);
									} else {
										setStartDate(newValue.format("YYYY-MM-DD"));
									}
								}}
								sx={{
									'& .MuiTextField-root': { m: 1, width: '200px' },
								}}
								renderInput={(params) => <TextField size="small" sx={{ ml: "5px", width: 180 }}{...params} />}
							/>
						</LocalizationProvider>
							<span className="datePickerText"> ~ </span>
						<LocalizationProvider dateAdapter={AdapterDayjs}>
							<DesktopDatePicker
								inputFormat={"YYYY-MM-DD"}
								mask={"____-__-__"}
								value={endDate}
								onChange={(newValue) => {
									if(newValue === null) {
										setEndDate(null);
									} else {
										setEndDate(newValue.format("YYYY-MM-DD"));
									}
								}}
								renderInput={(params) => <TextField size="small" sx={{ width: 180, mr: "25px"}}{...params} />}
							/>
						</LocalizationProvider>
					</>
				) : (
					<>
					</>
				)
			}
			<FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
				<Select
					labelId="demo-simple-select-standard-label"
					id="demo-simple-select-standard"
					value={selectItem}
					onChange={handleChange}
					sx={{ width: 160 }}
				>
					{
						options && options.map((options, index) => {
							return (
								<MenuItem key={index} value={options.value}>{options.item}</MenuItem>
							)
						})
					}
				</Select>
			</FormControl>
			{
				(selectItem !== "created") ? (
					<TextField
						sx={{ m: 1, width: 250 }}
						id="standard-search"
						value={inputValue}
						type="search"
						variant="standard"
						onChange={handleInput}
						placeholder="검색어를 입력하세요" 
					/>
				) : (
					<TextField
						sx={{ m: 1, width: 250 }}
						id="standard-search"
						value={inputValue}
						type="search"
						variant="standard"
						onChange={handleInput}
						placeholder="YYYY-MM-DD 형식으로 검색" 
					/>
				)
			}
			<IconButton sx={{ p: "10px"}} aria-label="search" onClick={() => {searchHandle(selectItem, inputValue, startDate, endDate)}}>
				<SearchIcon />
			</IconButton>
		</Box>
	)
}
